import { Component, EventEmitter, Input, Output } from '@angular/core';
import type { InnogyComponentRendering } from '@core/jss-models';
import { SingleArrayFieldStepViewModel } from '@innogy/shared/forms';
import { Store } from '@ngrx/store';
import type { AbstractControlState, FormControlValueTypes } from 'ngrx-forms';
import { AddArrayControlAction, RemoveArrayControlAction } from 'ngrx-forms';
import type { SingleFieldExplanationContent } from '@legacy/common-ui-utility-components';
import {
  ErrorCardComponent,
  MoreInfoButtonComponent,
} from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { TrackLinkDirective } from '@analytics/events';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

import type { ButtonOptions } from '../button-options/button-options.model';
import { SingleFieldQuestionContent } from '../../interfaces';
import { ProgressiveFormStepBaseComponent } from '../progressive-form-step.base.component';
import { ProgressiveFormService } from '../../progressive-form.service';
import { ProgressiveFormStepWrapperComponent } from '../../progressive-form-step-wrapper/progressive-form-step-wrapper.component';
import { ProgressiveFormBodyDirective } from '../../progressive-form-body.directive';
import { ProgressiveFormSummaryDirective } from '../../progressive-form-summary.directive';

@Component({
  selector:
    'wl-progressive-step-single-multivalue-question[progressiveFormSelectorKey][content]',
  templateUrl: './progressive-step-single-multivalue-question.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    ProgressiveFormStepWrapperComponent,
    ProgressiveFormBodyDirective,
    ErrorCardComponent,
    CSCaptureDirective,
    TrackLinkDirective,
    AutomationIdDirective,
    MoreInfoButtonComponent,
    ProgressiveFormSummaryDirective,
  ],
})
export class ProgressiveStepSingleMultivalueQuestionComponent<
  TFormFieldType extends FormControlValueTypes[],
> extends ProgressiveFormStepBaseComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override progressiveFormSelectorKey!: string;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override rendering: InnogyComponentRendering | undefined;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override content!: SingleFieldQuestionContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() override formStep?: SingleArrayFieldStepViewModel<TFormFieldType>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() questionOptions?: ButtonOptions[];
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() isReadonly = false;
  @Output()
  override giveMoreInfo: EventEmitter<SingleFieldExplanationContent> =
    new EventEmitter<SingleFieldExplanationContent>();

  constructor(
    private readonly store$: Store<any>,
    override readonly progressiveFormService: ProgressiveFormService
  ) {
    super(progressiveFormService);
  }

  isActive(value: any) {
    return this.formStep?.formState.value.field.includes(value);
  }

  setValue(value: any, control: AbstractControlState<any> | undefined) {
    if (control?.id == null) {
      return;
    }
    if (this.isActive(value)) {
      const index = this.formStep?.formState.value.field.indexOf(value);
      if (index != null) {
        this.store$.dispatch(new RemoveArrayControlAction(control?.id, index));
      }
    } else {
      this.store$.dispatch(new AddArrayControlAction(control?.id, value));
    }
  }
}
